export const ALL_BRANCHES_VALUE = 'ALL_BRANCHES' as const;
